import { Serializable } from '@/models/core/serializable';
import i18n from '@/i18n';

export class SchoolClass implements Serializable<SchoolClass> {
  grade: number; // 学年
  schoolClassID: number; // クラスID
  schoolClassName: string = ''; // クラス名

  selected: boolean;
  deleted: boolean = false; // 削除フラグ(クラス更新画面用)
  changed: boolean = false; // 更新フラグ(クラス更新画面用)
  created: boolean = false; // 追加フラグ(クラス更新画面用)

  deserialize(input: any): SchoolClass {
    this.grade = input.grade;
    this.schoolClassID = input.schoolClassID;
    this.schoolClassName = input.schoolClassName;

    if (input.deleted !== undefined) {
      this.deleted = input.deleted;
    }
    if (input.changed !== undefined) {
      this.changed = input.changed;
    }
    if (input.created !== undefined) {
      this.created = input.created;
    }

    return this;
  }

  get isNew(): boolean {
    return this.schoolClassID <= 0 || this.schoolClassID === undefined;
  }

  get schoolClassNameWithGrade() {
    return i18n.t('NUMBER_YEAR', {value: this.grade}).toString() + ` ${this.schoolClassName}`;
  }

  get gradeAndSchoolClassName() {
    return `${this.grade}-${this.schoolClassName}`;
  }
}

export class GradeClass implements Serializable<GradeClass> {
  grade: number;
  disabled: boolean;

  deserialize(input: any): GradeClass {
    this.grade = input.grade;
    return this;
  }
}

export class GradeSchoolClass implements Serializable<GradeSchoolClass> {
  grade: number;
  schoolClasses: SchoolClass[] = [];
  visible: boolean = true;

  deserialize(input: any): GradeSchoolClass {
    this.grade = input.grade;
    if (input.schoolClasses instanceof Array) {
      this.schoolClasses = input.schoolClasses.map((schoolClass: SchoolClass) => new SchoolClass().deserialize(schoolClass));
    }
    return this;
  }
}

export class SchoolClassSelection {
  grade: number;
  isCheckAll: boolean; // 全選択フラグ
  indeterminate: boolean; //全選択表示制御
  checkAllGroup: number[];

  constructor(grade: number, schoolClasses: SchoolClass[] = [], masterSchoolClasses: SchoolClass[] = []) {
    this.grade = grade;
    this.isCheckAll = false;
    this.indeterminate = false;
    this.checkAllGroup = [];

    //値のセットも含める場合
    if (schoolClasses && schoolClasses.length > 0) {
      this.checkAllGroup = schoolClasses.filter(d => d.grade === grade).map(d => d.schoolClassID);
      this.handleCheckAllGroupChange(masterSchoolClasses);
    }
  }

  notSelectedIDs(schoolClasses: SchoolClass[]) {
    return this.checkAllGroup.filter((schoolClassID: number) => !schoolClasses.find((schoolClass: SchoolClass) => schoolClass.schoolClassID === schoolClassID).selected);
  }

  setCheckAllGroup(schoolClasses: SchoolClass[]) {
    this.checkAllGroup = schoolClasses.filter(d => d.grade === this.grade).map(d => d.schoolClassID);
  }

  isChecked(): boolean {
    return this.checkAllGroup.length > 0;
  }

  handleCheckAll(data: SchoolClass[]) {
    if (this.indeterminate) {
      this.isCheckAll = false;
    } else {
      this.isCheckAll = !this.isCheckAll;
    }
    this.indeterminate = false;

    if (this.isCheckAll) {
      this.checkAllGroup = data.map(d => d.schoolClassID);
    } else {
      //すでに選択されたクラスについては全選択対象から除外する
      this.checkAllGroup = data.filter((schoolClass: SchoolClass) => schoolClass.selected).map(d => d.schoolClassID);
    }
  }

  handleCheckAllGroupChange(data: SchoolClass[]) {
    if (this.checkAllGroup.length === data.length) {
      this.indeterminate = false;
      this.isCheckAll = true;
    } else if (this.checkAllGroup.length > 0) {
      this.indeterminate = true;
      this.isCheckAll = false;
    } else {
      this.indeterminate = false;
      this.isCheckAll = false;
    }
  }
}
